export default "__VITE_ASSET__74b19381__"